class FooterAccordion extends HTMLElement {
    constructor() {
        super();

        this.toggleAccordion = this.toggleAccordion.bind(this);
        this.closeAccordion = this.closeAccordion.bind(this);
        this.toggleFooterAccordion = this.toggleFooterAccordion.bind(this);
        this.openFirstAccordionOnDesktop = this.openFirstAccordionOnDesktop.bind(this);
    }

    connectedCallback() {
        this.querySelectorAll('[data-level]').forEach(div => {
            div.addEventListener('click', this.toggleAccordion);
        });

        this.querySelectorAll('.footer-accordion-toggle').forEach(div => {
            div.addEventListener('click', this.toggleFooterAccordion);
        });

        this.openFirstAccordionOnDesktop();
        window.addEventListener('resize', this.openFirstAccordionOnDesktop);
    }

    disconnectedCallback() {
        this.querySelectorAll('[data-level]').forEach(div => {
            div.removeEventListener('click', this.toggleAccordion);
        });

        this.querySelectorAll('.footer-accordion-toggle').forEach(div => {
            div.removeEventListener('click', this.toggleFooterAccordion);
        });

        window.removeEventListener('resize', this.openFirstAccordionOnDesktop);
    }

    toggleAccordion(event) {
        const element = event.currentTarget;
        const level = element.getAttribute('data-level');
        const content = element.nextElementSibling;
        const icon = element.querySelector('.accordion-icon');

        const openItems = this.querySelectorAll(`.accordion-content[data-level="${level}-content"]`);
        openItems.forEach((item) => {
            if (item !== content) {
                this.closeAccordion(item);
            }
        });

        if (content.style.maxHeight === 'fit-content') {
            this.closeAccordion(content);
            icon.style.transform = 'rotate(90deg)';  // Set icon to 90 degrees when accordion is closed
        } else {
            content.style.maxHeight = 'fit-content';
            icon.style.transform = 'rotate(0deg)';  // Set icon to 0 degrees when accordion is open
        }
    }

    closeAccordion(content) {
        content.style.maxHeight = null;
        const icon = content.previousElementSibling.querySelector('.accordion-icon');
        if (icon) {
            icon.style.transform = 'rotate(90deg)';  // Ensure icon is at 90 degrees when closed
        }

        const nestedAccordions = content.querySelectorAll('.accordion-content');
        nestedAccordions.forEach(nestedContent => {
            nestedContent.style.maxHeight = null;
            const nestedIcon = nestedContent.previousElementSibling.querySelector('.accordion-icon');
            if (nestedIcon) {
                nestedIcon.style.transform = 'rotate(90deg)';  // Ensure nested icons are at 90 degrees when closed
            }
        });
    }

    toggleFooterAccordion(event) {
        const element = event.currentTarget;
        const content = element.nextElementSibling;
        const icon = element.querySelector('.accordion-icon');

        if (content.style.maxHeight === 'fit-content') {
            this.closeAccordion(content);
            icon.style.transform = 'rotate(90deg)';  // Set icon to 90 degrees when footer accordion is closed
        } else {
            content.style.maxHeight = 'fit-content';
            icon.style.transform = 'rotate(0deg)';  // Set icon to 0 degrees when footer accordion is open
        }
    }

    openFirstAccordionOnDesktop() {
        if (window.innerWidth > 750) {
            const firstAccordion = this.querySelector('.accordion-content') || this.querySelector('.footer-menu-content');
            if (firstAccordion) {
                firstAccordion.style.maxHeight = 'fit-content';
                const firstAccordionIcon = this.querySelector('.accordion-icon');
                if (firstAccordionIcon) {
                    firstAccordionIcon.style.transform = 'rotate(0deg)';  // Set the icon to 0 degrees for the first accordion
                }
            }
        }
    }
}

customElements.define('footer-accordion', FooterAccordion);